<nav class="breadcrumb-nav" aria-label="breadcrumbs">
  <a class="breadcrumb-link" routerLink="/audits">
    <i class="bi bi-house-door"></i>
    <span>Home</span>
  </a>

  <ng-container *ngIf="type() === 'profileReport'">
    <i class="bi bi-chevron-right separator"></i>
    <a class="breadcrumb-link" routerLink="/audits">Reports</a>
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Profile report</span>
  </ng-container>

  <ng-container *ngIf="type() === 'postReport'">
    <i class="bi bi-chevron-right separator"></i>
    <a class="breadcrumb-link" routerLink="/post/list">Post reports</a>
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Post report</span>
  </ng-container>

  <ng-container *ngIf="type() === 'newProfileReport'">
    <i class="bi bi-chevron-right separator"></i>
    <a class="breadcrumb-link" routerLink="/audits">Reports</a>
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">New profile report</span>
  </ng-container>

  <ng-container *ngIf="type() === 'newPostReport'">
    <i class="bi bi-chevron-right separator"></i>
    <a class="breadcrumb-link" routerLink="/post/list">Post reports</a>
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">New post report</span>
  </ng-container>

  <ng-container *ngIf="type() === 'profileReportsList'">
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Reports</span>
  </ng-container>

  <ng-container *ngIf="type() === 'postReportsList'">
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Post reports</span>
  </ng-container>

  <ng-container *ngIf="type() === 'compareProfiles'">
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Compare profiles</span>
  </ng-container>

  <ng-container *ngIf="type() === 'pricing'">
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Pricing</span>
  </ng-container>

  <ng-container *ngIf="type() === 'settings'">
    <i class="bi bi-chevron-right separator"></i>
    <span class="breadcrumb-current">Settings</span>
  </ng-container>
</nav>
